import { render, staticRenderFns } from "./ProveedoresReglasTarifas.vue?vue&type=template&id=28db34dd&scoped=true"
import script from "./ProveedoresReglasTarifas.vue?vue&type=script&lang=js"
export * from "./ProveedoresReglasTarifas.vue?vue&type=script&lang=js"
import style0 from "./ProveedoresReglasTarifas.vue?vue&type=style&index=0&id=28db34dd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28db34dd",
  null
  
)

export default component.exports